import { createFileRoute } from '@tanstack/react-router';
import OrdersManagement from '../../../components/manager/OrdersManagement';

export const Route = createFileRoute('/reception/orders/')({
  component: ReceptionOrdersIndex,
});

function ReceptionOrdersIndex() {
  return <OrdersManagement />;
}
